<!-- 公用内容区容器组件 -->
<template>
	<div class="commonOut">
		<div class="half">
			<TheHead :key="avatar"></TheHead>
			<div class="blank"></div>
			<div
				class="halfWrapper"
				@click="$store.state.showCate = false">
				<slot name="half"></slot>
			</div>
		</div>
		<div
			class="commonWrapper"
			@click="$store.state.showCate = false">
			<slot />
		</div>
		<TheFooter class="footer" />
	</div>
</template>

<script>
import TheFooter from './Footer.vue'
import TheHead from './Head.vue'
export default {
	name: 'Common',
	components: {
		TheHead,
		TheFooter,
	},
	data() {
		return {}
	},
	computed: {},
	methods: {},
}
</script>

<style lang="scss" scoped>
.commonOut {
	position: relative;
	background: #262529;
}
.blank {
	height: rem(80);
}
.commonWrapper {
	margin: auto;
}
.halfWrapper {
	margin: auto;
}

.half {
	background-image: url('../assets/bg.jpg');
	background-position: center center;
	/* 背景图不平铺 */
	background-repeat: no-repeat;
	background-attachment: fixed;
	/* 让背景图基于容器大小伸缩 */
	background-size: cover;
}
@media screen and (orientation: portrait) {
	.blank {
		height: rem(120);
	}
	.commonWrapper {
		max-width: 100%;
	}
}
@media screen and (orientation: landscape) {
	.commonWrapper {
		max-width: 75vw;
	}
}
</style>
